module.exports = __webpack_public_path__ + "img/Moldova.feb11ba1.png";